// extracted by mini-css-extract-plugin
export var dismissOverlay = "_br-b";
export var interactivePassthrough = "_br-3";
export var modal = "_br-d";
export var modalBackdrop = "_br-c";
export var modalBody = "_br-j";
export var modalDescription = "_br-m";
export var modalEnter = "_br-e";
export var modalFooter = "_br-n";
export var modalHeaderText = "_br-h";
export var modalIconCircle = "_br-i";
export var modalIconHeader = "_br-g";
export var modalImage = "_br-f";
export var modalSectionLabel = "_br-k";
export var modalTitle = "_br-l";
export var pulse = "_br-1";
export var pulseBorder = "_br-2";
export var spotlight = "_br-0";
export var tooltip = "_br-4";
export var tooltipButtons = "_br-9";
export var tooltipDescription = "_br-6";
export var tooltipFooter = "_br-7";
export var tooltipInteractivePill = "_br-a";
export var tooltipStepIndicator = "_br-8";
export var tooltipTitle = "_br-5";